<template>
  <Modal is-full-mobile :identifier="modalIdentifier">
    <template #header="slotProps">
      <div class="d-flex justify-content-between mx-n3 px-3 pb-3 border-bottom">
        <div class="h4 mb-0 flex-grow-1 text-left">{{ textChooseVendor }}</div>
        <button class="btn btn-reset p-0 float-right text-lg m-n3 p-3" @click="slotProps.close">
          <Close class="svg-fill-dark svg-24" />
        </button>
      </div>
    </template>
    <template #content>
      <div class="flex-grow-1 mb-n3 mx-n3 p-3 bg-gray-100">
        <button
          v-for="(vendor, index) in vendors"
          :key="index"
          class="btn btn-reset btn-block shadow-sm shadow-hover vendor-button"
          @click="chooseVendor(vendor)"
        >
          <div class="h6 mb-1 text-left">{{ vendor }}</div>
          <div class="px-1 border rounded text-xs delivery-option text-muted">
            {{ textDeliveryService }}
          </div>
        </button>
        <button class="btn btn-primary-link btn-block" @click="resetVendor">
          {{ textReset }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../Modal";
import Close from "../../../../icons/atalanda/close.svg";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "VendorFilterModal",
  components: {
    Modal,
    Close,
  },
  props: {
    textChooseVendor: {
      type: String,
      required: true,
    },
    textReset: {
      type: String,
      required: true,
    },
    textDeliveryService: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modalIdentifier: "essentialsVendorSelector",
    };
  },
  computed: {
    ...mapGetters({
      vendors: "lists/getFilterableVendors",
    }),
  },
  methods: {
    ...mapActions({
      setVendorFilter: "lists/setVendorFilter",
      hideModal: "hideModal",
    }),
    chooseVendor(value) {
      this.setVendorFilter(value);
      this.hideModal(this.modalIdentifier);
    },
    resetVendor() {
      this.setVendorFilter("");
      this.hideModal(this.modalIdentifier);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.vendor-button {
  position: relative;
  background: $white;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.delivery-option {
  text-transform: uppercase;
}
</style>
